module.exports = __webpack_public_path__ + "img/DE01406.49247932.png";